export enum ProductType {
    Goods = 1,
    Service = 2,
    ServicePack = 3,
    Options = 4,
    Combo = 5,
    OptionTopping = 6,
    OptionToppingGroup = 7
}
